import { render } from "./settings.vue?vue&type=template&id=291ff257&scoped=true&ts=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=291ff257&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291ff257"]])

export default __exports__